
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.707 8.022a6.685 6.685 0 11-13.37 0 6.685 6.685 0 0113.37 0zm-1.338 0a5.348 5.348 0 11-1.375-3.58l-4.641 4.64-1.867-1.867a.669.669 0 10-.946.946l1.867 1.867a1.337 1.337 0 001.891 0l4.47-4.47c.385.737.601 1.575.601 2.464z","fill":"currentColor"}})])
          )
        }
      }
    